import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ReportlinksserviceService } from 'src/app/user/reportlinks/reportlinksservice.service'; // Replace with the actual path
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service'; // Replace with the actual path

@Injectable({
  providedIn: 'root',
})

export class RetrieveScreenAccess {

    constructor(private linkservice: ReportlinksserviceService) { }

  find(button){
  
  //  this.linkservice.screenoperationspermission(button).subscribe(res => {
        
  //       console.log(res)
  //       if(res.error != true)
  //       {
  //       console.log(res);
  //       const buttonIdList: number[] = [];
  //       let responsedata: any ;
  //       responsedata = res;
  //       for (let i = 0; i <responsedata.length ; i++) {
          
  //        buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
  //        }
  //        return buttonIdList
  //       }
  //       console.log(res)
  //       return res 

  //      });

     }
}
